import type { BondingPace } from 'generated/openapi';
import { type ReactNode } from 'react';
import { z } from 'zod';

const bondingPaceEnum = z.enum<BondingPace[]>([
  'VERY_SLOW',
  'SLOW',
  'VERY_FAST',
  'INSTANT',
]);

import Handshake from '@/assets/icons/handshake.svg?react';

export interface BondingPaceOption {
  id: BondingPace;
  icon: ReactNode;
  label: string;
}

export const BONDING_PACE_MAP = new Map<BondingPace, BondingPaceOption>([
  [
    'VERY_SLOW',
    {
      id: 'VERY_SLOW',
      icon: <div>🌱</div>,
      label: 'I take my time to connect',
    },
  ],
  [
    'SLOW',
    {
      id: 'SLOW',
      icon: <Handshake />,
      label: 'Slowly but surely',
    },
  ],
  [
    'VERY_FAST',
    {
      id: 'VERY_FAST',
      icon: <div>🎮</div>,
      label: 'After a few games',
    },
  ],
  [
    'INSTANT',
    {
      id: 'INSTANT',
      icon: <div>⚡</div>,
      label: 'Instantly',
    },
  ],
]);

export const BONDING_PACE_OPTIONS: BondingPaceOption[] = Array.from(
  BONDING_PACE_MAP.values(),
);

export const BONDING_PACE_LABELS: Record<BondingPace, string> = {
  VERY_SLOW: 'I take my time to connect',
  SLOW: 'Slowly but surely',
  VERY_FAST: 'After a few games',
  INSTANT: 'Instantly',
};

export const bondingPaceSchema = bondingPaceEnum;
